import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { toNumber } from 'tiered-pricing/utils/toNumber';
import { TierPriceRowRange } from './TieredPriceRowRange';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TieredPriceRow = ({
  tierRangeAndPrice,
  currencyCode
}) => /*#__PURE__*/_jsxs("tr", {
  "data-test-id": "tier-table-row",
  children: [/*#__PURE__*/_jsx("td", {
    "data-test-id": "tier-table-row-index",
    children: tierRangeAndPrice.index + 1
  }), /*#__PURE__*/_jsx("td", {
    "data-test-id": "tier-table-row-range",
    children: /*#__PURE__*/_jsx(TierPriceRowRange, {
      tierRange: tierRangeAndPrice
    })
  }), /*#__PURE__*/_jsx("td", {
    "data-test-id": "tier-table-row-price",
    children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
      currencyCode: currencyCode,
      value: toNumber(tierRangeAndPrice.price)
    })
  })]
});